export const getSingleDocumentData = (payload?: any) => ({
    type: "@saga/GET_SINGLE_DOCUMENT_DATA",
    payload
});

